import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Receipt } from "lucide-react";
import { NeuCard, NeuInput } from "../../components/neu/Neu";
import { myPayslip } from "../../api/payroll";
import { PayslipLines } from "./PayslipLines";

export const PayslipCard = () => {
  const { t } = useTranslation();
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [slip, setSlip] = useState(null);

  useEffect(() => {
    myPayslip(month).then(setSlip).catch(() => setSlip(null));
  }, [month]);

  return (
    <NeuCard data-testid="payslip-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="label-xs flex items-center gap-2">
          <Receipt className="h-4 w-4 text-primary" /> {t("payslip.title")}
        </p>
        <NeuInput type="month" data-testid="payslip-month" value={month} onChange={(e) => setMonth(e.target.value)} className="w-40" />
      </div>

      {slip ? (
        <PayslipLines slip={slip} />
      ) : (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="payslip-empty">
          {t("payslip.empty")}
        </p>
      )}
    </NeuCard>
  );
};
